
class CitySource {
    constructor(API) {
        this.API = API;
    }

     async list(data) {
         return await this.API.get('/index.php?route=api/location/cities', {
             params: data
         })
     }
}


export default CitySource
